var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.taskLabel)?_c('p',{staticClass:"notification_label"},[_vm._v("You have an overdue task labeled '"+_vm._s(_vm.taskLabel)+"'")]):_c('p',{staticClass:"notification_label"},[_vm._v("You have an overdue task")]),_vm._v(" "),_c('button-link',{on:{"click":_vm.goToLead}},[_vm._v(_vm._s(_vm.notification.data.record_address))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }